<template>

    <div :class="[{'sample-segment': sampleSegment}, 'merge-result']">
        <el-row :gutter="24">
            
            <el-col :span="21">
                <SourceSegment v-model="textData" />
            </el-col>

            <el-col :span="1">
                <div class="slot-container">
                    <slot>

                    </slot>
                </div>
            </el-col>

        </el-row>
    </div>

</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import SourceSegment from '@/pages/Document/Segment/SourceSegmentView.vue'

    export default defineComponent({
        props: {
            modelValue: Object,
            sampleSegment: {
                type: Boolean,
                default: false
            }
        },
        components:{
            SourceSegment
        },
        data() {
            return {
                textData: {
                    text: '',
                    delta: {}
                },
            };
        },
        watch: {
            modelValue: {
                immediate: true,
                deep: true,
                handler(val: any) {
                    this.textData = val;
                }
            }
        }
    });
</script>

<style lang="scss" scoped>

    .merge-result {
        margin-bottom: 10px;
        padding: 10px;
        background-color: var(--light-blue);
        box-shadow: 1px 3px 5px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        width: 100%;
        box-sizing: border-box;
    }

    .sample-segment {
        background: var(--light-blue-focused);
    }

    .slot-container {
        display: flex;
        align-items: center;
        height: 100%;
    }

</style>